import { useEffect, useState } from 'react';

import PageLoader from 'Components/transitions/PageLoader/PageLoader';

const messages = [
  'Downloading secure module...',
  'Preparing your identity check...',
  'Verifying secure setup...',
  'Finalising secure setup...',
  'Checking progress...',
  'Nearly done...',
];

export const IncodeLoader = () => {
  const [currentMessageIndex, setCurrentMessageIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      const newIndex = currentMessageIndex + 1;

      if (newIndex >= messages.length) {
        clearInterval(timer);
        return;
      }

      setCurrentMessageIndex(newIndex);
    }, 2000);

    return () => clearInterval(timer);
  }, [currentMessageIndex]);

  return <PageLoader message={messages[currentMessageIndex]} />;
};
